export const greextraGlyphs = {
  MedicaeaFlat: "",
  HufnagelCustosUpShort: "",
  HufnagelCustosUpLong: "",
  HufnagelCustosUpMedium: "",
  HufnagelCustosDownShort: "",
  HufnagelCustosDownLong: "",
  HufnagelCustosDownMedium: "",
  MedicaeaCustosUpShort: "",
  MedicaeaCustosUpLong: "",
  MedicaeaCustosUpMedium: "",
  MedicaeaCustosDownShort: "",
  MedicaeaCustosDownLong: "",
  MedicaeaCustosDownMedium: "",
  MensuralCustosUpShort: "",
  MensuralCustosUpLong: "",
  MensuralCustosUpMedium: "",
  MensuralCustosDownShort: "",
  MensuralCustosDownLong: "",
  MensuralCustosDownMedium: "",
  MensuralFlat: "",
  HufnagelFlat: "",
  MedicaeaCClef: "",
  MedicaeaCClefChange: "",
  MedicaeaFClef: "",
  MedicaeaFClefChange: "",
  HufnagelCClef: "",
  HufnagelCClefChange: "",
  HufnagelFClef: "",
  HufnagelFClefChange: "",
  HugnagelCFClef: "",
  HufnagelCFClefChange: "",
  MensuralFlatHole: "",
  HufnagelFlatHole: "",
  MedicaeaFlatHole: "",
  StarSix: "",
  Dagger: "",
  "Bar.alt": "",
  StarHeight: "",
  Cross: "",
  "RBar.alt": "",
  "VBar.alt": "",
  Drawing1: "",
  Drawing2: "",
  RWithBarGoth: "",
  VWithBarGoth: "",
  Line1: "",
  Line2: "",
  Line3: "",
  Line4: "",
  Line5: "",
  "Cross.alt": "",
  ABarCaption: "",
  RBarCaption: "",
  VBarCaption: "",
  ABarCaptionSC: "",
  RBarCaptionSC: "",
  VBarCaptionSC: "",
  ABar: "",
  RBar: "",
  VBar: "",
  ABarSC: "",
  RBarSC: "",
  VBarSC: "",
  ABarSmall: "",
  RBarSmall: "",
  VBarSmall: "",
  ABarSmallSC: "",
  RBarSmallSC: "",
  VBarSmallSC: "",
  "RBar.alt2": "",
  "VBar.alt2": "",
  ABarCaptionSlant: "",
  RBarCaptionSlant: "",
  VBarCaptionSlant: "",
  ABarSlant: "",
  RBarSlant: "",
  VBarSlant: "",
  ABarSmallSlant: "",
  RBarSmallSlant: "",
  VBarSmallSlant: ""
};



// WEBPACK FOOTER //
// ./src/greextraGlyphs.js